import { render } from "./FacturasMatriculaList.vue?vue&type=template&id=d1fc1702"
import script from "./FacturasMatriculaList.vue?vue&type=script&lang=js"
export * from "./FacturasMatriculaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__